import { useState } from 'react'

import { getEmbedUrlForId } from './youtube'

interface Props {
  youtubeId: string
}
export function YoutubeIframe({ youtubeId }: Props) {
  const [iframeLoaded, setIframeLoaded] = useState(false)

  const handleLoadIframe = () => {
    setIframeLoaded(true)
  }
  const origin = typeof window === 'undefined' ? '' : window.location.origin

  return (
    <div className="faq-answer-youtube">
      <iframe
        className={iframeLoaded ? '' : 'hidden'}
        onLoad={handleLoadIframe}
        src={getEmbedUrlForId(youtubeId, { rel: '0', origin })}
        title="YouTube video player"
        allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </div>
  )
}
